/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import React, { useEffect, useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import Header from "./header"
import Footer from "./footer"
import { ParallaxProvider } from "react-scroll-parallax"

const Layout = ({ children }) => {

  const [animateHeader, setAnimateHeader] = useState(false)

  useEffect(() => {
    const listener = () => {
      if (window.scrollY > 140) {
        setAnimateHeader(true)
      } else setAnimateHeader(false)
    }

    window.addEventListener("scroll", listener)

    return () => {
      window.removeEventListener("scroll", listener)
    }
  })

  const data = useStaticQuery(
    graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `
  )

  return (
    <ParallaxProvider>
      <div className={`${animateHeader && "pt-1 sm:pt-1 sm:pb-1"} transition-colors duration-500`}>
        <Header siteTitle={data.site.siteMetadata?.title || `Title`} />

        <div className="bg-black">
          <main>{children}</main>
        </div>

        <Footer dataAos="fade-up" dataAosDelay="0" siteTitle={data.site.siteMetadata?.title || `Title`} />
      </div>
    </ParallaxProvider>
  )
}

export default Layout